import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import UploadPesertaParticipant from 'components/pages/modal/participant/peserta/uploadDataParticipant'
import ModalPesertaAktif from 'components/pages/modal/participant/peserta/pesertaAktif/modalPesertaAktif'
import { alert, confirm } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'
import notify from 'devextreme/ui/notify'

class RegistrasiPesertaAktif extends Component {
  constructor(props) {
    super(props)

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.dataGridRef = React.createRef()
    this.modalPesertaAktifRef = React.createRef()
    this.modalAddPesertaAktifRef = React.createRef()
    this.modalEditPesertaAktifRef = React.createRef()

    this.selectedRowsData = []

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Detail',
            hint: 'edit',
            onClick: (e) => {
              this.modalEditPesertaAktifRef.current.show()
              this.modalEditPesertaAktifRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Kirim',
            hint: 'edit',
            onClick: async (e) => {
              let result = await confirm(
                'Apakah anda yakin mengirim data ini ?',
                'Konfirmasi'
              )
              if (result) {
                this.sendData(e.row.key)
              }
            },
          },
        ],
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'namaLengkap',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'tanggalLahir',
        caption: 'Tanggal Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'produkPensiun',
        caption: 'Dana Pensiun',
      },
      {
        dataField: 'iuranNormalPesertaPpip1',
        caption: 'Jumlah Iuran',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'participantPesertaUploadId',
        caption: 'Entry',
        cellRender: (e) => {
          if (e.row.data.participantPesertaUploadId) {
            return 'Upload'
          } else {
            return 'Manual'
          }
        },
      },
      {
        dataField: 'statusId',
        caption: 'Status',
        lookup: {
          dataSource: [
            { id: 1, name: 'Open' },
            { id: 2, name: 'Kirim' },
          ],
          displayExpr: 'name',
          valueExpr: 'id',
        },
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  onSelectionChanged = (e) => {
    this.selectedRowsData = e.selectedRowsData
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-delete-dapen-default' },
          onClick: (e) => {
            if (this.selectedRowsData.length > 0) {
              this.batalPeserta()
            } else {
              alert('Silahkkan pilih data terlebih dahulu!', 'Informasi')
            }
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          text: 'Kirim',
          elementAttr: { class: 'bg-button-send-dapen-default' },
          onClick: async (e) => {
            if (this.selectedRowsData.length > 0) {
              let result = await confirm(
                'Apakah anda yakin mengirim data ini ?',
                'Konfirmasi'
              )
              if (result) {
                this.kirimPeserta()
              }
            } else {
              alert('Silahkkan pilih data terlebih dahulu!', 'Informasi')
            }
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'upload',
          text: 'Upload Registrasi Baru',
          elementAttr: { class: 'bg-button-upload-dapen-default' },
          onClick: (e) => {
            this.modalPesertaAktifRef.current.show()
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          text: 'Input Manual',
          elementAttr: { class: 'bg-button-add-dapen-default' },
          onClick: (e) => {
            this.modalAddPesertaAktifRef.current.show()
          },
        },
      }
    )
  }

  loadData = async () => {
    const resultData = []
    const getData = await httpRequest(
      process.env.REACT_APP_BACKEND_CORE,
      this.props.store,
      'participant-peserta-upload-dtls?size=9999',
      'GET'
    )
    for (let value of getData) {
      const data = {
        ...value,
        entry: value.participantPesertaUploadId ? 'Upload' : 'Manual',
      }

      resultData.push(data)
    }

    return resultData
  }

  sendData = async (id) => {
    let ids = []
    ids.push(id)
    if (ids.length > 0) {
      try {
        await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          'wp/pesertas/kirim-reg-peserta-aktif',
          'POST',
          {
            values: {
              participantId:
                this.props.store.getState().sessionUser.participantId,
              requestIds: ids,
            },
          }
        )

        this.forceRefresh()
        notify(
          {
            message: 'Berhasil Simpan Data!',
            width: 'AUTO',
            shading: true,
            position: { at: 'center', my: 'center', of: window },
          },
          'success',
          1000
        )
      } catch (err) {
        console.log(err)
      }
    }
  }

  batalPeserta = async () => {
    let getData = this.selectedRowsData
    let id = []

    for (let value of getData) {
      id.push({
        ids: value.id,
      })
    }

    const idsArray = id.map((item) => item.ids)

    if (id.length > 0) {
      try {
        await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `participant-peserta-upload-dtls/bulk`,
          'DELETEARRAY',
          idsArray
        )

        notify(
          {
            message: 'Data Berhasil Dihapus',
            width: 'AUTO',
            shading: true,
            position: { at: 'center', my: 'center', of: window },
          },
          'success',
          600
        )
        this.forceRefresh()
      } catch (e) {
        notify(
          {
            message: 'Terjadi Kesalahan',
            width: 'AUTO',
            shading: true,
            position: { at: 'center', my: 'center', of: window },
          },
          'error',
          600
        )
      }
    }
  }

  kirimPeserta = async () => {
    let getData = this.selectedRowsData
    let id = []

    for (let value of getData) {
      id.push(value.id)
    }

    if (id.length > 0) {
      try {
        await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          'wp/pesertas/kirim-reg-peserta-aktif',
          'POST',
          {
            values: {
              participantId:
                this.props.store.getState().sessionUser.participantId,
              requestIds: id,
            },
          }
        )

        this.forceRefresh()
        notify(
          {
            message: 'Berhasil Simpan Data!',
            width: 'AUTO',
            shading: true,
            position: { at: 'center', my: 'center', of: window },
          },
          'success',
          1000
        )
      } catch (e) {
        notify(
          {
            message: 'Terjadi Kesalahan',
            width: 'AUTO',
            shading: true,
            position: { at: 'center', my: 'center', of: window },
          },
          'error',
          600
        )
      }
    }
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Registrasi Peserta Aktif</h2>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI={`participant-peserta-upload-dtls?statusId.in=1&participantId.equals=${this.participantId}`}
          insertAPI="participant-peserta-upload-dtls"
          updateAPI="participant-peserta-upload-dtls"
          deleteAPI="participant-peserta-upload-dtls"
          backendserver={process.env.REACT_APP_BACKEND_CORE}
          remoteOperations={true}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          exportExcel={false}
          exportFileName={'Registrasi Peserta Aktif'}
          allowExportSelectedData={true}
          selection={'multiple'}
          showBorders={true}
          paging={true}
          defaultPageSize={10}
          height={'80vh'}
          popupTitle={'Registrasi Peserta Aktif'}
          popupWidth={700}
          popupHeight={500}
          popupFormLabelLocation="left"
          popupFormMinColWidth={300}
          popupFormColCount={3}
          ColumnChooser={true}
          ColumnFixing={true}
          FilterRow={true}
          ColumnConfiguration={this.columns}
          SummaryConfiguration={this.summary}
          onToolbarPreparing={this.onToolbarPreparing}
          onSelectionChanged={this.onSelectionChanged}
          store={this.props.store}
        />

        <ModalPesertaAktif
          ref={this.modalAddPesertaAktifRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          actionType="add"
        />
        <ModalPesertaAktif
          ref={this.modalEditPesertaAktifRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          actionType="edit"
        />
        <UploadPesertaParticipant
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          ref={this.modalPesertaAktifRef}
        />
      </div>
    )
  }
}

export default RegistrasiPesertaAktif
